module.exports = __webpack_public_path__ + "static/media/se.79da0f18.svg";